import { Component, Input } from '@angular/core';
import { FieldOkItemComponent } from '@softline/dynamic';

@Component({
  selector: 'soft-field-ok-vkforg-list-view',
  imports: [],
  templateUrl: './vkforg.list-view.html',
  styleUrls: ['./vkforg.list-view.css'],
})
export class VkforgListView implements FieldOkItemComponent<any> {
  @Input() item: any;
}
